import React from 'react';
import {appGetUrlPath} from '../function_lib/common_cms';
export function Single_Img_Msg(lsData){
    var appPath= appGetUrlPath();
    var strResp="";
    for(var i=0;i<lsData.length;i++){
        strResp+="<div  data-aos=\"fade-up\" data-aos-duration=\"1100\" class=\"border-box section pt-50px\">"+
        "<div class=\"container\">"+
            "<div class=\"row align-items-center\">"+
                "<div class=\"col-lg-3\">"+
                    "<div class=\"about-left-image mb-md-30px mb-lm-30px\" data-aos=\"fade-up\">"+
                        "<img src=\""+appPath+lsData[i]["col4"]+"\" alt=\"\" class=\"img-responsive w-100\" />"+
                    "</div>"+
                "</div>"+
                "<div class=\"col-lg-9\">"+
                    "<div class=\"about-content\">"+
                        "<div class=\"about-title\" data-aos=\"fade-up\">"+
                            "<h2>"+lsData[i]["col1"]+"</h2>"+
                        "</div>"+
                        "<p class=\"mb-6\" data-aos=\"fade-up\" data-aos-delay=\"200\">"+
                           lsData[i]["col2"]+
                        "</p>"+
                        "<p data-aos=\"fade-up\" data-aos-delay=\"300\">"+
                        lsData[i]["col3"]+
                        "</p>"+
                    "</div>"+
               "</div>"+
            "</div>"+
        "</div>"+
        "</div>";
    }
    return strResp;

}
export default Single_Img_Msg;